import { InjectionToken } from '@angular/core';

export const REFERER = new InjectionToken<string>('referer');
